<template>
  <div>
    <nav class="flex justify-between bg-white">
      <TabLink
        to="/local-admin/sessions"
        :name="$t('global.defaults.session', 2)"
        icon="session"
      ></TabLink>
      <TabLink
        v-if="!staff"
        to="/local-admin/local-users"
        :name="$t('global.defaults.localUser', 2)"
        icon="users"
      ></TabLink>
      <TabLink
        to="/local-admin/remote-users"
        :name="$t('global.defaults.remoteUser', 2)"
        icon="remote-users"
      ></TabLink>
      <TabLink
        v-if="!staff"
        to="/local-admin/usage"
        :name="$t('global.defaults.usage')"
        icon="usage"
      ></TabLink>
    </nav>

    <HeaderShadow></HeaderShadow>

    <router-view />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import HeaderShadow from "@/components/utils/HeaderShadow.vue";
import TabLink from "@/components/utils/TabLink.vue";

@Options({
  components: {
    TabLink,
    HeaderShadow,
  },
  computed: {
    staff() {
      return this.$store.getters.getStaff;
    },
  },
})
export default class LocalAdmin extends Vue {}
</script>
